import { extractProjectKey } from '@jira/platform__issue-key-parsing/src/extractProjectKey.tsx';
import {
	buildIssueQuery,
	buildIssueQueryV2,
	ISSUE_VIEW_INTERACTIVE_QUERY,
} from '@jira/issue__issue-view-interactive-query/src/buildIssueQuery.tsx';
import { getClient } from '@jira/issue__reliability-fetch/src/getClient.tsx';
import getMeta from '@jira/platform__utils-get-meta/src/utils/get-meta/index.tsx';
import { metrics } from '@atlassian/browser-metrics/factory';
import type { GraphQlResponse } from './ForgeResponse.types.tsx';

type IssueKey = string;

const ISSUE_GIRA_DATA = 'issue-gira-data';
const timeToFetchIssueGiraDataMetric = metrics.custom({
	key: ISSUE_GIRA_DATA,
});

const fetchIssueGiraData = async (issueKey: IssueKey): Promise<GraphQlResponse> => {
	const cloudId = getMeta('ajs-cloud-id');
	const projectKey = extractProjectKey(issueKey);
	const variables = {
		issueKey,
		projectKey,
		...(cloudId ? { cloudId } : {}),
	};

	const payload = {
		query: cloudId ? buildIssueQueryV2() : buildIssueQuery(),
		variables,
		operationName: ISSUE_VIEW_INTERACTIVE_QUERY,
	};
	const isInSample = (sampleRate = 100) => Math.random() <= 1 / sampleRate;

	if (isInSample()) {
		timeToFetchIssueGiraDataMetric.start();
	}

	try {
		const response: GraphQlResponse = await getClient(
			'issue-fetch-service/src/services/issue-gira-data/index',
		).query(payload);

		// Best-effort attempt to provide `issueId` and is not guaranteed
		const issueId = response.data?.viewIssue?.issueId;

		timeToFetchIssueGiraDataMetric.stop({
			customData: issueId ? { issueId } : null,
		});

		return response;
		// oxlint-disable-next-line @typescript-eslint/no-explicit-any
	} catch (error: any) {
		// Cancel the metric and re-throw the error
		timeToFetchIssueGiraDataMetric.cancel();
		throw error;
	}
};

export default fetchIssueGiraData;
